import { css } from 'linaria';

export const root = css`
    display: contents;
`;
